import { render, staticRenderFns } from "./quick-details-ada.vue?vue&type=template&id=e83ce712&scoped=true"
import script from "./quick-details-ada.vue?vue&type=script&lang=ts"
export * from "./quick-details-ada.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83ce712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\WebDev\\Source\\PeppermillReno.com\\[DEV]\\[WEB] PeppermillReno.com DEV\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e83ce712')) {
      api.createRecord('e83ce712', component.options)
    } else {
      api.reload('e83ce712', component.options)
    }
    module.hot.accept("./quick-details-ada.vue?vue&type=template&id=e83ce712&scoped=true", function () {
      api.rerender('e83ce712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "library/js/components/view-room-details/quick-details-ada.vue"
export default component.exports